// extracted by mini-css-extract-plugin
export default {"seoComponents":"SeoComponents_seoComponents__MzI0N"};